/* ==========================================================================
   Shiok Booking Gate
   --------------------------------------------------------------------------
   Menahan Add to Cart untuk produk chef/assistant di SEMUA jalur masuk
   (halaman produk, quick add, product recommendation), meminta data booking
   sekali per keranjang, lalu menyerahkan kembali penambahan ke handler tema.

   Prinsip:
   - Data booking milik ACARA (cart attributes), bukan milik baris.
   - Kode ini TIDAK menambahkan produk utama ke keranjang. Tema yang melakukannya.
   - Surcharge: satu baris, quantity = jumlah crew (chef/assistant) di
     keranjang. Per manpower sejak 04-10-2026 (Boss + Rara), menggantikan
     aturan lama "quantity selalu 1".
   - Fail open. Kalau apa pun gagal, pelanggan tetap bisa checkout.

   04-10-2026 (Boss): semua paket di koleksi live-station-bbq-chef dan
   live-station-bbq-assistant-package ikut gerbang. Jumlah crew per varian
   dihitung staffFor(): metafield custom.staff_count, lalu angka di judul
   varian ("2 BBQ Assistants"), lalu pax terbesar dibagi paxPerCrew (25)
   dibulatkan ke atas, lalu 1. Angka di judul MENANG atas rumus pax walau
   berbeda (keputusan Boss), karena itu yang dibaca pelanggan.

   05-10-2026 (Boss): hire chef/assistant mengikuti Number of Guests. Kebutuhan
   crew = tamu / 25 dibulatkan ke atas (crew paket di keranjang ikut dihitung).
   Kekurangannya muncul sebagai peringatan di bawah field tamu, lalu ditambahkan
   otomatis sebagai varian "Only" (tanpa alat). Kalau customer menguranginya di
   keranjang, popup Edit dibuka dengan peringatan; simpan atau tutup tanpa
   menurunkan tamu = crew yang kurang ditambahkan kembali. Crew tidak pernah
   dikurangi otomatis.

   30-09-2026 (Boss): tanggal paling awal per produk (minDays dari metafield
   my_fields.min_lead_days, default 1 = besok), peringatan bayar hari ini di
   hari minDays sampai minDays + payWarnExtraDays - 1, dan copy jasa murni
   (disclaimer, kalimat kedatangan) hanya untuk serviceOnly. Satu booking per
   keranjang tetap berlaku, jadi syaratnya diambil dari produk TERBERAT di
   keranjang plus produk yang sedang ditambahkan. Untuk chef/assistant saja
   (minDays 1) semua jalur berperilaku persis seperti sebelumnya.
   ========================================================================== */

(function () {
  'use strict';

  var CFG = null;
  try {
    var el = document.getElementById('shiok-booking-gate-config');
    CFG = JSON.parse(el.textContent);
  } catch (e) {
    return; // tanpa konfigurasi, gerbang tidak aktif. Toko tetap jalan normal.
  }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var ATTR = {
    date:     'Event Date',
    time:     'Booking Time',
    duration: 'Dining Duration',
    guests:   'Number of Guests',
    notes:    'Additional Notes',
    surcharge:'Last-Minute Surcharge'
  };

  var state = {
    form: null,          // form yang sedang ditahan
    variantId: null,
    booking: null,       // { date, time, duration, guests, notes }
    mode: 'add',         // 'add' = sedang menambah produk, 'edit' = mengubah dari keranjang
    rule: { days: 1, title: '', serviceOnly: true },  // syarat tanggal yang berlaku di modal
    addServiceOnly: true, // produk yang sedang ditambahkan adalah jasa murni
    crewBase: 0,         // crew yang sudah ada di keranjang saat modal dibuka
    crewAdd: 0,          // crew dari produk yang sedang ditambahkan (0 saat edit)
    hireVid: null,       // varian hire chef/assistant yang ikut booking ini (aturan jumlah tamu)
    nextReason: null,    // 'external' kalau reconcile dipicu perubahan keranjang oleh customer/tema
    reconciling: false,
    reconcileTimer: null
  };

  /* ======================================================================
     1. Waktu. SEMUA perhitungan diikat ke Asia/Singapore (UTC+8),
        bukan ke zona waktu browser pelanggan.
     ====================================================================== */

  var SGT_OFFSET_MIN = 8 * 60;

  // "sekarang" dalam komponen tanggal waktu Singapura
  function sgtNowParts() {
    var now = new Date();
    var utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
    return new Date(utcMs + SGT_OFFSET_MIN * 60000);
  }

  // yyyy-mm-dd dari komponen lokal sebuah Date (tanpa lewat toISOString)
  function toDateString(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }

  function tomorrowSGT() {
    var d = sgtNowParts();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 1);
    return toDateString(d);
  }

  // Tanggal n hari dari hari ini, waktu Singapura. n = 1 sama dengan tomorrowSGT().
  function sgtPlusDays(n) {
    var d = sgtNowParts();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + n);
    return toDateString(d);
  }

  // Berapa hari kalender dari hari ini (SGT) ke tanggal yyyy-mm-dd.
  function daysFromTodaySGT(dateStr) {
    var t = sgtNowParts();
    t.setHours(0, 0, 0, 0);
    var p = String(dateStr || '').split('-').map(Number);
    if (p.length !== 3 || !p[0]) return null;
    return Math.round((new Date(p[0], p[1] - 1, p[2]).getTime() - t.getTime()) / 86400000);
  }

  function niceDate(dateStr) {
    var d = sgtInstant(dateStr, '12:00 PM');
    return d ? d.toLocaleDateString('en-SG', {
      weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Singapore'
    }) : dateStr;
  }

  // "5:30 PM" -> { h: 17, m: 30 }
  function parse12h(t) {
    var m = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(String(t || '').trim());
    if (!m) return null;
    var h = parseInt(m[1], 10) % 12;
    if (/PM/i.test(m[3])) h += 12;
    return { h: h, m: parseInt(m[2], 10) };
  }

  // Instant absolut dari tanggal+jam yang DIANGGAP waktu Singapura.
  function sgtInstant(dateStr, timeStr) {
    if (!dateStr) return null;
    var hm = parse12h(timeStr) || { h: 0, m: 0 };
    var iso = dateStr + 'T' +
      String(hm.h).padStart(2, '0') + ':' +
      String(hm.m).padStart(2, '0') + ':00+08:00';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }

  // Jam dari SEKARANG sampai MULAI acara. Titik ukur = jam mulai (Booking Time).
  function hoursUntilEvent(dateStr, timeStr) {
    var start = sgtInstant(dateStr, timeStr);
    if (!start) return null;
    return (start.getTime() - Date.now()) / 3600000;
  }

  /* ======================================================================
     2. Band surcharge. Batas inklusif: tepat 24,0 jam masuk band $100.
     ====================================================================== */

  function bandFor(dateStr, timeStr) {
    if (!CFG.surcharge || !CFG.surcharge.enabled) return null;
    var hrs = hoursUntilEvent(dateStr, timeStr);
    if (hrs === null || hrs < 0) return null;
    var bands = CFG.surcharge.bands || [];
    for (var i = 0; i < bands.length; i++) {
      if (hrs <= bands[i].maxHours) return bands[i];
    }
    return null;
  }

  function bandSentence(b) {
    return b.sentence || ('within ' + b.maxHours + ' hours');
  }

  function money(n) {
    return '$' + Number(n).toFixed(2).replace(/\.00$/, '');
  }

  /* ======================================================================
     3. Cart API
     ====================================================================== */

  /* Penanda _sbg=1 dipasang di SEMUA permintaan milik gerbang sendiri, supaya
     pengamat perubahan keranjang bisa mengabaikannya tanpa perlu menebak lewat
     flag waktu. Versi sebelumnya memakai `!state.reconciling` sebagai syarat,
     dan itu ikut menelan perubahan dari LUAR: waktu tema menambahkan chef ke
     keranjang sementara satu reconcile masih berjalan, penjadwalannya dilewati
     dan surcharge tidak pernah ditambahkan. */
  var SELF = '_sbg=1';
  function selfUrl(path) { return ROOT + path + (path.indexOf('?') === -1 ? '?' : '&') + SELF; }

  function cartFetch(path, body) {
    return fetch(selfUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch(selfUrl('cart.js'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  function setAttributes(attrs) { return cartFetch('cart/update.js', { attributes: attrs }); }
  function addItems(items)      { return cartFetch('cart/add.js', { items: items }); }
  function changeLine(key, patch) {
    var body = { id: key };
    if (patch.quantity !== undefined)   body.quantity = patch.quantity;
    if (patch.properties !== undefined) body.properties = patch.properties;
    return cartFetch('cart/change.js', body);
  }

  /* ======================================================================
     4. Klasifikasi baris keranjang
     ====================================================================== */

  /* Jumlah crew (chef/assistant) untuk SATU unit varian. Urutan sumber:
     1. metafield varian custom.staff_count (admin bisa mengoreksi tanpa kode)
     2. angka di judul varian, "2 BBQ Assistants" / "1 BBQ Chef"
     3. pax terbesar di judul, dibagi paxPerCrew lalu dibulatkan ke atas
        (Rara 04-10-2026: 1 chef atau assistant untuk 20-25 pax; Boss memilih
        batas atas range, "22-28pax" = 2)
     4. 1, misalnya Satay yang variannya bukan pax (keputusan Boss). */
  var PAX_PER_CREW = CFG.paxPerCrew > 0 ? CFG.paxPerCrew : 25;
  function staffFromTitle(title) {
    var t = String(title || '');
    var c = /(\d+)\s*BBQ\s*(?:Chef|Assistant)s?\b/i.exec(t);
    if (c) return Math.max(1, parseInt(c[1], 10));
    var p = /(\d+)\s*(?:-\s*(\d+))?\s*pax/i.exec(t);
    if (p) {
      var top = parseInt(p[2] || p[1], 10);
      if (top > 0) return Math.max(1, Math.ceil(top / PAX_PER_CREW));
    }
    return 1;
  }
  function staffFor(variantId) {
    var e = CFG.gatedVariants[String(variantId)];
    if (!e) return 0;
    var o = parseInt(e.staffOverride, 10);
    if (o > 0) return o;
    return staffFromTitle(e.variantTitle);
  }
  // Total crew dari baris keranjang: crew per unit x quantity baris.
  function crewOfLines(lines) {
    return (lines || []).reduce(function (n, it) {
      return n + staffFor(it.variant_id) * (parseInt(it.quantity, 10) || 0);
    }, 0);
  }
  function crewWord(n) { return n === 1 ? '1 crew member' : n + ' crew members'; }

  /* JUMLAH TAMU (Boss 05-10-2026). Untuk hire chef/assistant, kebutuhan crew =
     Number of Guests dibagi PAX_PER_CREW dibulatkan ke atas: 1-25 tamu = 1,
     26-50 = 2, 51-75 = 3, 76-100 = 4. Kekurangan ditambahkan sebagai varian
     "Only" (tanpa alat) dari produk hire yang sama. Paket tidak ikut aturan
     ini, crew paket sudah tertulis di variannya, tapi crew paket DIHITUNG
     sebagai crew yang sudah ada. */
  /* B (Boss + Parkson 05-10-2026): di atas 100 tamu efisiensi tim naik, jadi
     website TIDAK menambah crew di atas jumlah untuk 100 tamu (4). Tim yang
     mengonfirmasi crew final, popup menulis catatannya. */
  var CREW_GUEST_CAP = 100;
  function crewNeeded(guests) {
    var g = parseInt(guests, 10);
    return g > 0 ? Math.ceil(Math.min(g, CREW_GUEST_CAP) / PAX_PER_CREW) : 0;
  }
  function overCap(guests) { return parseInt(guests, 10) > CREW_GUEST_CAP; }
  // Varian hire yang menjadi dasar penambahan: punya onlyVariant yang tersedia.
  function isHire(variantId) {
    var e = entryFor(variantId);
    return isServiceOnly(variantId) && Number(e.onlyVariant) > 0;
  }
  /* A (Jay 05-10-2026): booking dengan hire BBQ Chef tidak pernah mendapat
     Additional. Sampai 60 tamu tim mengirim bantuan tanpa biaya (alur internal,
     sengaja tidak ditulis ke customer); di atas 60 hanya saran menambah 1 BBQ
     Assistant. Jadi firstHire mengembalikan null kalau ada chef hire. */
  function isHireChef(v) { return isHire(v) && roleOfHire(v) === 'BBQ Chef'; }
  function isHireAssistant(v) { return isHire(v) && roleOfHire(v) === 'BBQ Assistant'; }
  function hasHireChef(ids) { return (ids || []).some(isHireChef); }
  function firstHire(variantIds) {
    if (hasHireChef(variantIds)) return null;
    for (var i = 0; i < (variantIds || []).length; i++) if (isHire(variantIds[i])) return variantIds[i];
    return null;
  }
  var CHEF_SUGGEST_ABOVE = 60;
  function assistantOnlyPrice() {
    var ids = Object.keys(CFG.gatedVariants);
    for (var i = 0; i < ids.length; i++) {
      var e = CFG.gatedVariants[ids[i]];
      if (e.role === 'BBQ Assistant' && Number(e.onlyPrice) > 0) return Number(e.onlyPrice);
    }
    return 0;
  }
  function plural(word, n) { return n === 1 ? word : word + 's'; }

  /* Baris crew TAMBAHAN yang dibuat sistem (Boss 05-10-2026): TIDAK membawa
     data booking, hanya dua keterangan pendek seperti baris surcharge, plus
     penanda tersembunyi (awalan "_" disembunyikan keranjang dan checkout).
     Teksnya sengaja pendek supaya rapi di HP. */
  var TOPUP_KEY = '_sbg_topup';
  function isTopUp(it) { return !!(it && it.properties && it.properties[TOPUP_KEY]); }
  function notTopUp(it) { return !isTopUp(it); }
  function topUpProps(booking, need, hireVid) {
    var role = roleOfHire(hireVid);
    var p = {};
    p['Why this charge'] = overCap(booking.guests)
      ? 'Your ' + booking.guests + ' guests need at least ' + need + ' ' + plural(role, need) + '.'
      : 'Your ' + booking.guests + ' guests need ' + need + ' ' + plural(role, need) +
        ', one for every ' + PAX_PER_CREW + ' guests.';
    p['How to remove'] = 'Tap Remove or Edit, then lower the Number of Guests.';
    p[TOPUP_KEY] = '1';
    return p;
  }
  function sameProps(a, b) {
    a = a || {}; b = b || {};
    var ka = Object.keys(a).filter(function (k) { return a[k] !== '' && a[k] != null; }).sort();
    var kb = Object.keys(b).sort();
    if (ka.join('|') !== kb.join('|')) return false;
    return ka.every(function (k) { return String(a[k]) === String(b[k]); });
  }
  function roleOfHire(variantId) { return entryFor(variantId).role || 'BBQ Chef'; }
  // "2 BBQ Assistants" untuk properti baris paket, supaya admin melihat dasar hitungannya.
  function crewLabel(variantId) {
    var n = staffFor(variantId);
    var e = entryFor(variantId);
    // Judul varian dulu (Atas: "Casual BBQ With Assistant" / "... With Chef"), baru judul produk.
    var roleOf = function (t) { return /assistant/i.test(t) ? 'BBQ Assistant' : (/chef/i.test(t) ? 'BBQ Chef' : ''); };
    var role = roleOf(e.variantTitle || '') || roleOf(e.productTitle || '') || 'Crew Member';
    return n + ' ' + role + (n === 1 ? '' : 's');
  }

  function isGated(variantId)    { return Object.prototype.hasOwnProperty.call(CFG.gatedVariants, String(variantId)); }
  function isSurcharge(variantId){ return (CFG.surcharge.allVariantIds || []).indexOf(Number(variantId)) !== -1; }

  function entryFor(variantId)   { return CFG.gatedVariants[String(variantId)] || {}; }
  function minDaysFor(variantId) { var n = parseInt(entryFor(variantId).minDays, 10); return n > 0 ? n : 1; }
  // !== false: konfigurasi lama tanpa kunci ini tetap dianggap jasa murni.
  function isServiceOnly(variantId) { return entryFor(variantId).serviceOnly !== false; }

  // Syarat terberat dari sekumpulan variant: jumlah hari terbesar menang.
  function ruleFor(variantIds) {
    var r = { days: 1, title: '', serviceOnly: true };
    (variantIds || []).forEach(function (v) {
      var d = minDaysFor(v);
      if (d > r.days) { r.days = d; r.title = entryFor(v).productTitle || ''; }
      if (!isServiceOnly(v)) r.serviceOnly = false;
    });
    return r;
  }

  function splitCart(cart) {
    var chef = [], sur = [];
    (cart.items || []).forEach(function (it) {
      if (isGated(it.variant_id)) chef.push(it);
      else if (isSurcharge(it.variant_id)) sur.push(it);
    });
    return { chef: chef, sur: sur };
  }

  /* KEPUTUSAN BOSS 04-10-2026 (dari Rara, admin): surcharge PER MANPOWER.
     Quantity baris surcharge = total crew di keranjang, jadi BBQ Assistant
     qty 2 = surcharge qty 2, dan paket "2 BBQ Assistants" = surcharge qty 2.
     Ini membatalkan aturan 20-09-2026 "selalu quantity 1". */
  function wantQty(chefLines) { return crewOfLines(chefLines); }

  // Teks nilai surcharge untuk cart attribute, contoh "$200 (Within 24hrs, 2 crew x $100)".
  function surchargeText(band, crew) {
    if (!band) return 'No surcharge';
    var n = crew > 0 ? crew : 1;
    return money(band.amount * n) + ' (' + band.label + ', ' + n + ' crew x ' + money(band.amount) + ')';
  }

  function bookingFromCart(cart) {
    var a = cart.attributes || {};
    if (!a[ATTR.date]) return null;
    return {
      date: a[ATTR.date],
      time: a[ATTR.time] || '',
      duration: a[ATTR.duration] || '',
      guests: a[ATTR.guests] || '',
      notes: a[ATTR.notes] || ''
    };
  }

  /* Boss 30-09-2026: HANYA produk dengan scheduleNote (lamb saja, diatur di
     snippet) membawa satu baris tambahan untuk tim, karena GAF di /cart tetap
     meminta Delivery Date dan tanggalnya bisa berbeda dari acara. */
  var SCHEDULE_KEY = 'Schedule';
  var SCHEDULE_TEXT = 'Follow the Event Date and Booking Time above. Ignore the Delivery Date if it differs.';

  function propsFor(booking, band, variantId) {
    var p = {};
    p[ATTR.time]     = booking.time;
    p[ATTR.date]     = booking.date;
    p[ATTR.duration] = booking.duration;
    p[ATTR.guests]   = String(booking.guests);
    if (booking.notes) p[ATTR.notes] = booking.notes;
    // Per baris: tarif per crew. Total ada di baris surcharge dan cart attribute.
    p[ATTR.surcharge] = band
      ? money(band.amount) + ' per crew member (' + band.label + ')'
      : 'No surcharge';
    // Paket: jumlah crew yang dihitung, supaya admin melihat dasar quantity surcharge.
    if (variantId !== undefined && isGated(variantId) && !isServiceOnly(variantId)) p[CREW_KEY] = crewLabel(variantId);
    if (variantId !== undefined && entryFor(variantId).scheduleNote === true) p[SCHEDULE_KEY] = SCHEDULE_TEXT;
    return p;
  }
  var CREW_KEY = 'Crew';

  function attrsFor(booking, band, crew) {
    var a = {};
    a[ATTR.date]      = booking.date;
    a[ATTR.time]      = booking.time;
    a[ATTR.duration]  = booking.duration;
    a[ATTR.guests]    = String(booking.guests);
    a[ATTR.notes]     = booking.notes || '';
    a[ATTR.surcharge] = surchargeText(band, crew);
    return a;
  }

  /* ======================================================================
     5. Rekonsiliasi. Enam aturan, tiap aturan menutup satu kegagalan
        yang benar benar pernah terjadi di order asli.
     ====================================================================== */

  /* Reconcile dijalankan BERURUT lewat satu rantai promise.

     Versi sebelumnya memakai flag `state.reconciling` sebagai penjaga masuk:
     kalau sedang berjalan, panggilan baru langsung pulang. Dua akibatnya, dan
     dua duanya sudah terjadi di live:
       1. Panggilan yang datang saat putaran lain berjalan HILANG, padahal
          justru dia yang tahu kondisi keranjang paling baru.
       2. Kalau satu putaran gagal di tengah tanpa mencapai baris penutup,
          flag itu macet `true` selamanya dan SEMUA reconcile berikutnya mati
          diam diam. Inilah yang membuat surcharge tidak terhapus waktu Boss
          mengubah tanggal lewat Edit.
     Sekarang tiap panggilan disambung ke ekor rantai, jadi tidak ada yang
     hilang, dan pelepasan flag ada di blok penutup yang selalu dijalankan
     baik saat sukses maupun gagal. */
  var reconcileChain = Promise.resolve();

  function reconcile() {
    reconcileChain = reconcileChain.then(runReconcileOnce, runReconcileOnce);
    return reconcileChain;
  }

  /* Indikator sibuk untuk reconcile, dinyalakan MALAS.

     Dulu busy(true) dipanggil di awal putaran. Itu keliru: reconcile berjalan
     di SETIAP page load dan sebagian besar kali tidak ada yang perlu diubah,
     jadi "Updating your cart..." berkedip di seluruh situs padahal tidak
     terjadi apa apa. (Boss, 20-09-2026) Sekarang penyalaannya pindah ke
     mark(), yaitu saat penulisan pertama ke Cart API benar benar dikirim.

     Pasangan on/off ini idempoten dan memakai satu penanda, bukan state.changed,
     karena ekor putaran sudah me-reset state.changed ke false SEBELUM .catch
     penutup bisa berjalan. Kalau pematiannya bergantung pada state.changed,
     ada jalur galat yang meninggalkan indikator menyala selamanya.
     Aman memakai penanda tingkat modul karena reconcile dijalankan berantai
     satu per satu lewat reconcileChain, tidak pernah tumpang tindih. */
  var reconcileBusy = false;
  function reconcileBusyOn()  { if (!reconcileBusy) { reconcileBusy = true;  busy(true); } }
  function reconcileBusyOff() { if (reconcileBusy)  { reconcileBusy = false; busy(false); } }

  function runReconcileOnce() {
    state.reconciling = true;
    state.changed = false;

    var selesaiRapi = function () {
      state.reconciling = false;
      reconcileBusyOff();
    };

    return getCart().then(function (cart) {
      var parts = splitCart(cart);
      var booking = bookingFromCart(cart);
      var band = booking ? bandFor(booking.date, booking.time) : null;
      var chain = Promise.resolve();
      var reason = state.nextReason;
      state.nextReason = null;

      // Penahan: selama modal terbuka atau beberapa detik sesudah Confirm,
      // atribut sengaja sudah tersimpan sementara produknya belum masuk.
      var holdAttrs = (ui.overlay && ui.overlay.getAttribute('data-open') === 'true') ||
        Date.now() < (state.holdAttrsUntil || 0);

      // Aturan jumlah tamu (Boss 05-10-2026), hanya kalau ada hire chef/assistant.
      // Baris TAMBAHAN (penanda tersembunyi _sbg_topup) milik sistem: ikut
      // jumlah tamu naik maupun turun. Baris pilihan customer tidak pernah
      // dikurangi otomatis.
      var custLines = parts.chef.filter(function (it) { return !isTopUp(it); });
      var topLines = parts.chef.filter(isTopUp);
      var have = wantQty(custLines);
      var topQty = topLines.reduce(function (n, it) { return n + it.quantity; }, 0);
      var need = booking ? crewNeeded(booking.guests) : 0;
      var hireVid = firstHire(custLines.map(function (it) { return it.variant_id; }));
      var wantTop = (hireVid && need > have) ? need - have : 0;
      // Customer sendiri yang mengurangi di keranjang: buka popup Edit dengan
      // peringatan dulu, jangan langsung ditambah. Menyimpan tanpa menurunkan
      // tamu, atau menutup popup, menjalankan reconcile biasa yang menambahkan.
      if (wantTop > topQty && reason === 'external' && !holdAttrs) {
        var bk = booking, hv = hireVid;
        setTimeout(function () { askCrewReduction(bk, hv); }, 0);
        wantTop = topQty;
      }
      var onlyId = hireVid ? Number(entryFor(hireVid).onlyVariant) : 0;
      var expTop = (hireVid && wantTop > 0) ? topUpProps(booking, need, hireVid) : null;
      var keepTop = null;
      topLines.forEach(function (it) {
        if (!keepTop && wantTop > 0 && Number(it.variant_id) === onlyId) keepTop = it;
        else chain = chain.then(function () { return mark(changeLine(it.key, { quantity: 0 })); });
      });
      if (wantTop > 0 && !keepTop) {
        var addQ = wantTop;
        chain = chain.then(function () {
          return mark(addItems([{ id: onlyId, quantity: addQ, properties: expTop }]));
        });
      } else if (wantTop > 0 && !sameProps(keepTop.properties, expTop)) {
        var kt = keepTop, q1 = wantTop;
        chain = chain.then(function () { return mark(changeLine(kt.key, { quantity: q1, properties: expTop })); });
      } else if (wantTop > 0 && keepTop.quantity !== wantTop) {
        var kt2 = keepTop, q2 = wantTop;
        chain = chain.then(function () { return mark(changeLine(kt2.key, { quantity: q2 })); });
      }
      // Tanpa baris pilihan customer, baris tambahan sudah dilepas di atas,
      // jadi aturan di bawah memperlakukan keranjang sebagai tanpa crew.
      parts.chef = custLines;
      var want = parts.chef.length ? have + wantTop : 0;

      // Nilai cart attribute surcharge mengikuti total crew. Berubah kalau
      // pelanggan menaikkan quantity atau menambah paket lain.
      if (booking && parts.chef.length) {
        var wantText = surchargeText(band, want);
        if ((cart.attributes || {})[ATTR.surcharge] !== wantText) {
          var sa = {}; sa[ATTR.surcharge] = wantText;
          chain = chain.then(function () { return mark(setAttributes(sa)); });
        }
      }

      // aturan 1: tidak ada chef lagi, surcharge harus ikut hilang  (#3666).
      // 04-10-2026: juga saat tidak ada baris surcharge tapi booking masih
      // tersimpan, supaya Event Date lama tidak ikut ke order berikutnya yang
      // tanpa crew (terukur di theme dev: atribut tertinggal sesudah keranjang
      // dikosongkan pada tanggal tanpa surcharge).
      // (holdAttrs dihitung di atas.)
      if (!parts.chef.length && !parts.sur.length && booking && holdAttrs) {
        // Dicek lagi sesudah penahan waktu habis, supaya booking yatim tetap
        // dibersihkan. Penahan "modal terbuka" dilepas oleh hide().
        var sisa = (state.holdAttrsUntil || 0) - Date.now();
        if (sisa > 0) setTimeout(function () { scheduleReconcile(); }, sisa + 500);
        return chain;
      }
      if (!parts.chef.length && (parts.sur.length || booking)) {
        parts.sur.forEach(function (it) {
          chain = chain.then(function () { return mark(changeLine(it.key, { quantity: 0 })); });
        });
        if (booking) chain = chain.then(function () { return mark(setAttributes(blankAttrs())); });
        return chain;
      }

      if (!parts.chef.length) return chain;

      // aturan 2: tanggal sudah jauh, surcharge harus hilang
      if (!band && parts.sur.length) {
        parts.sur.forEach(function (it) {
          chain = chain.then(function () { return mark(changeLine(it.key, { quantity: 0 })); });
        });
        return chain;
      }

      if (!band) return chain;

      // aturan 6: lebih dari satu baris surcharge, sisakan satu  (#3666)
      var keep = null;
      parts.sur.forEach(function (it, i) {
        if (i === 0) keep = it;
        else chain = chain.then(function () { return mark(changeLine(it.key, { quantity: 0 })); });
      });

      // aturan 3: chef ada, surcharge tidak ada, tambahkan  (#3888)
      if (!keep) {
        chain = chain.then(function () {
          return mark(addItems([{ id: band.variantId, quantity: want, properties: surchargeProps(band) }]));
        });
        return chain;
      }

      // aturan 4: variant surcharge salah band, tukar
      if (Number(keep.variant_id) !== Number(band.variantId)) {
        chain = chain
          .then(function () { return mark(changeLine(keep.key, { quantity: 0 })); })
          .then(function () {
            return mark(addItems([{ id: band.variantId, quantity: want, properties: surchargeProps(band) }]));
          });
        return chain;
      }

      // aturan 5: quantity = total crew (per manpower sejak 04-10-2026).
      // Pelanggan tidak bisa mengubahnya sendiri, reconcile selalu mengembalikan.
      if (want > 0 && keep.quantity !== want) {
        chain = chain.then(function () { return mark(changeLine(keep.key, { quantity: want })); });
      }

      return chain;
    })
      .catch(function () { /* fail open, diam saja */ })
      .then(function () {
        state.reconciling = false;          // dilepas sebelum render ulang
        var berubah = state.changed;
        state.changed = false;
        return getCart().then(function (c) {
          document.dispatchEvent(new CustomEvent('sbg:cart-updated', { detail: c }));
          var pr = berubah ? refreshCartView() : Promise.resolve();
          return pr.then(function () { reconcileBusyOff(); return c; });
        });
      })
      .catch(function () { selesaiRapi(); });
  }

  // Menandai bahwa keranjang benar benar berubah, supaya tampilan disegarkan.
  // Sekaligus titik penyalaan indikator: lihat keterangan di reconcileBusyOn.
  function mark(p) { reconcileBusyOn(); state.changed = true; return p; }

  /* Keterangan di baris surcharge. Boss sempat minta dikosongkan, lalu
     MEMBATALKANNYA setelah melihat hasilnya di live (20-09-2026): dua baris ini
     dipertahankan karena menjelaskan kenapa biaya muncul dan bagaimana
     menghilangkannya, tepat di tempat pelanggan melihatnya. */
  function surchargeProps(band) {
    return {
      'Why this charge': 'Your event is ' + bandSentence(band) + ' at the time of booking.',
      'How to remove': 'Change the Event Date on your booking.'
    };
  }

  function blankAttrs() {
    var a = {};
    Object.keys(ATTR).forEach(function (k) { a[ATTR[k]] = ''; });
    return a;
  }

  /* reason 'external' = perubahan keranjang dari customer/tema (pemantau fetch).
     reason 'force' = jalankan aturan biasa tanpa bertanya (popup baru ditutup).
     Tanpa reason, nilai yang sudah tercatat dipertahankan. */
  function scheduleReconcile(reason) {
    if (reason === 'external') state.nextReason = 'external';
    else if (reason === 'force') state.nextReason = null;
    clearTimeout(state.reconcileTimer);
    state.reconcileTimer = setTimeout(reconcile, 220);
  }

  /* Menyegarkan keranjang yang sudah terlanjur dirender.

     Versi pertama memakai location.reload() dengan pembatas anti loop di
     sessionStorage. Itu keliru: penghitungnya mentok setelah beberapa operasi
     lalu reload berhenti terjadi diam diam, sehingga server sudah berubah tapi
     layar tetap menampilkan angka lama. Sekarang halamannya dirender ulang di
     tempat, tanpa reload sama sekali, jadi tidak ada penghitung dan tidak ada
     kemungkinan loop. */
  function swap(doc, id) {
    var src = doc.getElementById(id);
    var dst = document.getElementById(id);
    if (!src || !dst) return;
    dst.innerHTML = src.innerHTML;
    if (typeof dst.ajaxifyCartItems === 'function') { try { dst.ajaxifyCartItems(); } catch (e) {} }
  }

  function refreshCartView() {
    var onCartPage = document.body.classList.contains('template-cart');
    var url = onCartPage
      ? (location.pathname + '?sbg=' + Date.now())
      : (ROOT + '?section_id=helper-cart&sbg=' + Date.now());

    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        swap(doc, 'AjaxCartForm');
        swap(doc, 'AjaxCartSubtotal');

        var cnt = document.querySelector('#AjaxCartForm [data-cart-count]');
        var tot = document.querySelector('#AjaxCartForm [data-cart-total]');
        if (cnt) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = cnt.textContent; });
        if (tot) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = tot.textContent; });

        if (onCartPage) {
          // halaman cart punya ringkasan sendiri di luar dua container itu
          ['cart-subtotal', 'CartSubtotal'].forEach(function (id) { swap(doc, id); });
          var sSrc = doc.querySelector('.cart__details, .cart-summary');
          var sDst = document.querySelector('.cart__details, .cart-summary');
          if (sSrc && sDst) sDst.innerHTML = sSrc.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* Indikator sibuk. Boss meminta tanda kalau ada jeda, karena gerbang ini
     memang bicara ke Cart API Shopify dan itu perlu waktu. */
  /* Keranjangnya sedang terlihat atau tidak. Kalau pelanggan ada di homepage
     atau halaman produk, pekerjaan di latar belakang tidak perlu diumumkan,
     karena tidak ada yang bisa dia lihat berubah. (Boss, 20-09-2026)

     Halaman cart TIDAK dideteksi dari location.pathname, karena awalan lokal
     seperti /en-sg/cart akan meleset, dan tidak dari #AjaxCartForm, karena id
     itu dipakai ganda oleh drawer dan halaman cart. Liquid tahu pasti lewat
     template.name, jadi jawabannya dititipkan di konfigurasi.
     Kelas sidebar--opened dipasang dan dilepas oleh SidebarDrawer milik tema
     di section-header.js. */
  function cartVisible() {
    if (CFG.onCartPage) return true;
    var d = document.getElementById('site-cart-sidebar');
    return !!(d && d.classList.contains('sidebar--opened'));
  }

  var busyCount = 0;
  function busy(on) {
    busyCount = Math.max(0, busyCount + (on ? 1 : -1));
    // Hitungannya tetap berjalan seperti biasa. Yang disaring hanya tampilannya,
    // jadi tidak ada risiko hitungan jadi tidak seimbang.
    var nyala = busyCount > 0 && cartVisible();
    var el = document.getElementById('sbg-busy');
    if (!el) {
      if (!nyala) return;   // jangan pasang elemennya kalau memang tidak dipakai
      el = document.createElement('div');
      el.id = 'sbg-busy';
      el.className = 'sbg-busy sbg-root';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML = '<span class="sbg-busy-dot"></span><span>Updating your cart...</span>';
      document.body.appendChild(el);
    }
    el.setAttribute('data-on', nyala ? 'true' : 'false');
  }

  /* ======================================================================
     6. Pantau perubahan keranjang dari mana pun (termasuk kode tema)
     ====================================================================== */

  (function watchCartMutations() {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var p = orig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && url.indexOf(SELF) === -1) {
          p.then(function () { scheduleReconcile('external'); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  })();

  /* ======================================================================
     7. Modal
     ====================================================================== */

  var ui = {};

  function cacheUI() {
    ui.overlay   = document.getElementById('sbg-overlay');
    if (!ui.overlay) return false;
    ui.subtitle  = document.getElementById('sbg-subtitle');
    ui.arrival   = document.getElementById('sbg-arrival-notice');
    ui.modeFull  = document.getElementById('sbg-mode-full');
    ui.modeQuick = document.getElementById('sbg-mode-quick');
    ui.summary   = document.getElementById('sbg-summary');
    ui.confirm   = document.getElementById('sbg-confirm');
    ui.change    = document.getElementById('sbg-change');
    ui.close     = document.getElementById('sbg-close');
    ui.time      = document.getElementById('sbg-booking-time');
    ui.date      = document.getElementById('sbg-event-date');
    ui.duration  = document.getElementById('sbg-duration');
    ui.guests    = document.getElementById('sbg-guests');
    ui.notes     = document.getElementById('sbg-notes');
    ui.sur       = document.getElementById('sbg-surcharge');
    ui.surAmt    = document.getElementById('sbg-surcharge-amount');
    ui.surBody   = document.getElementById('sbg-surcharge-body');
    ui.surCalc   = document.getElementById('sbg-surcharge-calc');
    ui.surQ      = document.getElementById('sbg-surcharge-quick');
    ui.surQAmt   = document.getElementById('sbg-surcharge-quick-amount');
    ui.surQCalc  = document.getElementById('sbg-surcharge-quick-calc');
    ui.dateHelp  = document.getElementById('sbg-date-help');
    ui.dateError = document.getElementById('sbg-date-error');
    ui.payWarn   = document.getElementById('sbg-paywarn');
    ui.payWarnB  = document.getElementById('sbg-paywarn-body');
    ui.payWarnQ  = document.getElementById('sbg-paywarn-quick');
    ui.payWarnQB = document.getElementById('sbg-paywarn-quick-body');
    ui.discFull  = document.getElementById('sbg-disclaimer-full');
    ui.discQuick = document.getElementById('sbg-disclaimer-quick');
    ui.crewWarn  = document.getElementById('sbg-crewwarn');
    ui.crewWarnB = document.getElementById('sbg-crewwarn-body');
    ui.crewWarnQ = document.getElementById('sbg-crewwarn-quick');
    ui.crewWarnQB= document.getElementById('sbg-crewwarn-quick-body');
    ui.capWarn   = document.getElementById('sbg-capwarn');
    ui.capWarnB  = document.getElementById('sbg-capwarn-body');
    return true;
  }

  function fieldEl(name) { return document.querySelector('.sbg-field[data-field="' + name + '"]'); }

  function setInvalid(name, bad) {
    var f = fieldEl(name);
    if (f) f.setAttribute('data-invalid', bad ? 'true' : 'false');
  }

  function readForm() {
    return {
      date: ui.date.value,
      time: ui.time.value,
      duration: ui.duration.value,
      guests: ui.guests.value,
      notes: ui.notes.value.trim()
    };
  }

  function validate(showErrors) {
    var b = readForm();
    var ok = { time: !!b.time, date: !!b.date && b.date >= sgtPlusDays(state.rule.days),
               duration: !!b.duration, guests: !!b.guests && Number(b.guests) >= 1 };
    if (showErrors) Object.keys(ok).forEach(function (k) { setInvalid(k, !ok[k]); });
    return ok.time && ok.date && ok.duration && ok.guests;
  }

  // Jumlah tamu yang sedang berlaku di modal: field di mode penuh, booking di mode cepat.
  function currentGuests() {
    if (ui.modeQuick && !ui.modeQuick.hidden) return state.booking ? state.booking.guests : '';
    return ui.guests ? ui.guests.value : '';
  }
  // Kekurangan crew menurut jumlah tamu, null kalau tidak ada hire atau sudah cukup.
  function crewGap() {
    if (!state.hireVid) return null;
    var g = parseInt(currentGuests(), 10);
    var need = crewNeeded(g);
    var have = (state.crewBase || 0) + (state.crewAdd || 0);
    return need > have ? { guests: g, need: need, have: have, extra: need - have } : null;
  }
  function crewTotal() {
    var gap = crewGap();
    return Math.max(1, gap ? gap.need : (state.crewBase || 0) + (state.crewAdd || 0));
  }

  /* Peringatan di bawah Number of Guests (Boss 05-10-2026). Contoh:
     "Your 30 guests need 2 BBQ Assistants, one for every 25 guests. We will add
     1 more BBQ Assistant without extra equipment ($310 each). If you need fewer
     BBQ Assistants, you must lower the Number of Guests." */
  function crewWarnText() {
    var gap = crewGap();
    if (!gap) return '';
    var e = entryFor(state.hireVid);
    var role = roleOfHire(state.hireVid);
    var price = Number(e.onlyPrice) > 0 ? ' (' + money(e.onlyPrice) + ' each)' : '';
    // Edit: baris tambahan dikelola sistem (bisa sudah ada di keranjang), jadi
    // kalimatnya menyatakan isi booking, bukan janji menambah.
    // Kalau keranjang SUDAH berisi Additional (state.topQty), jumlahnya bisa
    // naik atau turun, jadi kalimatnya menyebut isi akhir, bukan "add more".
    // (Boss 05-10-2026: "This adds 5" dan "add 4 more" menyesatkan saat paket
    // berisi crew ditambahkan dan Additional justru berkurang.)
    var middle = state.mode === 'edit'
      ? ', so your booking includes ' + gap.extra + ' additional ' + plural(role, gap.extra) +
        ' without extra equipment' + price + '.'
      : (state.topQty || 0) > 0
        ? ', so your booking will include ' + gap.extra + ' additional ' + plural(role, gap.extra) +
          ' without extra equipment' + price + '.'
        : '. We will add ' + gap.extra + ' more ' + plural(role, gap.extra) +
          ' without extra equipment' + price + ' to your cart.';
    var needTxt = overCap(gap.guests)
      ? 'Your ' + gap.guests + ' guests need at least ' + gap.need + ' ' + plural(role, gap.need)
      : 'Your ' + gap.guests + ' guests need ' + gap.need + ' ' + plural(role, gap.need) +
        ', one for every ' + PAX_PER_CREW + ' guests';
    return needTxt + middle + ' If you need fewer ' +
      plural(role, 2) + ', you must ' +
      (ui.modeQuick && !ui.modeQuick.hidden ? 'choose Change booking details and ' : '') +
      'lower the Number of Guests.';
  }
  /* KAPASITAS PAKET (Boss 05-10-2026): "9-12 pax tapi tamunya 300" diblok.
     Kapasitas = pax teratas di judul varian x quantity, dijumlah untuk semua
     makanan di keranjang (paket gerbang, paket DIY, lamb) plus paket yang
     sedang ditambahkan. Hanya memicu kalau ada paket GERBANG yang menulis pax,
     jadi hire chef/assistant tanpa paket (bawa makanan sendiri) dan Satay
     (varian bukan pax) tidak pernah diblok. */
  function paxTop(title) {
    var p = /(\d+)\s*(?:-\s*(\d+))?\s*pax/i.exec(String(title || ''));
    return p ? parseInt(p[2] || p[1], 10) || 0 : 0;
  }
  function foodLines(cart) {
    return (cart.items || []).filter(function (it) {
      if (isSurcharge(it.variant_id) || isTopUp(it)) return false;
      return !(isGated(it.variant_id) && isServiceOnly(it.variant_id));
    }).map(function (it) {
      return { title: it.variant_title || '', qty: it.quantity, gated: isGated(it.variant_id) };
    });
  }
  function topQtyOf(cart) {
    return (cart.items || []).filter(isTopUp).reduce(function (n, it) { return n + it.quantity; }, 0);
  }
  function capacityGap() {
    var lines = (state.cartFood || []).slice();
    var v = state.variantId;
    if (v && isGated(v) && !isServiceOnly(v)) {
      lines.push({ title: entryFor(v).variantTitle || '', qty: formQty(state.form), gated: true });
    }
    var trig = lines.some(function (l) { return l.gated && paxTop(l.title) > 0; });
    if (!trig) return null;
    var cap = lines.reduce(function (n, l) { return n + paxTop(l.title) * (l.qty || 0); }, 0);
    var g = parseInt(currentGuests(), 10);
    return (g > 0 && cap > 0 && g > cap) ? { cap: cap, guests: g } : null;
  }
  function renderCapacity() {
    var gap = capacityGap();
    state.capBlocked = !!gap;
    var quick = ui.modeQuick && !ui.modeQuick.hidden;
    if (ui.capWarn && ui.capWarnB) {
      ui.capWarnB.textContent = gap
        ? 'Your packages serve up to ' + gap.cap + ' guests, but your booking has ' + gap.guests +
          ' guests. To continue, choose a bigger package size or ' +
          (quick ? 'choose Change booking details and ' : '') + 'lower the Number of Guests.'
        : '';
      ui.capWarn.setAttribute('data-active', gap ? 'true' : 'false');
    }
    if (ui.confirm && ui.confirm.getAttribute('data-busy') !== 'true') {
      ui.confirm.disabled = !!gap;
      ui.confirm.setAttribute('aria-disabled', gap ? 'true' : 'false');
    }
  }

  function renderCrewWarn() {
    renderCapacity();   // dihitung di setiap titik yang sama (buka modal, ketik tamu)
    var t = crewWarnText();
    var g = parseInt(currentGuests(), 10);
    var ids = state.bookingIds || [];
    if (state.hireVid && overCap(g)) {
      t = (t ? t + ' ' : '') + 'For more than ' + CREW_GUEST_CAP +
        ' guests, our team will confirm the number of crew with you.';
    }
    if (hasHireChef(ids) && g > CHEF_SUGGEST_ABOVE && !ids.some(isHireAssistant)) {
      var ap = assistantOnlyPrice();
      t = 'For more than ' + CHEF_SUGGEST_ABOVE + ' guests, we recommend adding 1 BBQ Assistant' +
        (ap ? ' (' + money(ap) + ')' : '') + '.';
    }
    var quick = ui.modeQuick && !ui.modeQuick.hidden;
    var box = quick ? ui.crewWarnQ : ui.crewWarn, body = quick ? ui.crewWarnQB : ui.crewWarnB;
    var other = quick ? ui.crewWarn : ui.crewWarnQ;
    if (other) other.setAttribute('data-active', 'false');
    if (!box || !body) return;
    body.textContent = t;
    box.setAttribute('data-active', t ? 'true' : 'false');
  }

  /* Customer mengurangi chef/assistant di keranjang sampai di bawah kebutuhan
     tamunya (Boss 05-10-2026): buka popup Edit booking details dengan
     peringatan. Simpan dengan tamu lebih sedikit = jumlah baru diterima.
     Simpan tanpa mengubah, atau tutup popup = crew yang kurang ditambahkan. */
  function askCrewReduction(booking, hireVid) {
    if (!booking || (ui.overlay && ui.overlay.getAttribute('data-open') === 'true')) return;
    getCart().then(function (cart) {
      var chefLines = splitCart(cart).chef.filter(notTopUp);  // tanpa baris tambahan sistem
      state.cartFood = foodLines(cart); state.topQty = topQtyOf(cart);  // kapasitas paket + Additional yang sudah ada
      state.form = null;
      state.variantId = null;
      state.booking = booking;
      state.crewBase = crewOfLines(chefLines);
      state.crewAdd = 0;
      state.hireVid = hireVid;
      state.bookingIds = chefLines.map(function (it) { return it.variant_id; });
      openFull('', booking, 'edit', ruleFor(chefLines.map(function (it) { return it.variant_id; })));
      var role = roleOfHire(hireVid);
      ui.arrival.textContent = 'You lowered the number of ' + plural(role, 2) + ' in your cart. ' +
        'Please check your booking details below.';
    });
  }

  // Quantity yang akan ditambahkan form. form.elements ikut membaca input yang
  // berada di luar tag form tapi terhubung lewat atribut form="...".
  function formQty(form) {
    try {
      var q = form && form.elements ? form.elements.namedItem('quantity') : null;
      if (q && q.length !== undefined && !q.value) q = q[0];
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    } catch (e) { return 1; }
  }

  function renderSurcharge() {
    var b = readForm();
    var band = (b.date && b.time) ? bandFor(b.date, b.time) : null;
    if (!band) { ui.sur.setAttribute('data-active', 'false'); return; }
    var crew = crewTotal();
    ui.sur.setAttribute('data-active', 'true');
    ui.surAmt.textContent = money(band.amount * crew);
    ui.surBody.textContent =
      'Your event is ' + bandSentence(band) + '. A last-minute fee of ' + money(band.amount) +
      ' per chef or assistant applies and will be added to your cart as a separate item. It cannot be ' +
      'removed while a chef or assistant is in your cart. To remove it, choose an event date further ahead.';
    var hrs = hoursUntilEvent(b.date, b.time);
    ui.surCalc.textContent = 'Your booking has ' + crewWord(crew) + ', so the fee is ' + crew + ' x ' +
      money(band.amount) + ' = ' + money(band.amount * crew) + '. Time until your event is about ' +
      Math.floor(hrs) + ' hours.';
  }

  /* Peringatan bayar hari ini (Boss 30-09-2026). Hanya untuk produk dengan
     minDays di atas 1, di hari minDays sampai minDays + PAY_WARN_EXTRA - 1. */
  var PAY_WARN_EXTRA = CFG.payWarnExtraDays > 0 ? CFG.payWarnExtraDays : 2;
  function payWarnText(dateStr) {
    var r = state.rule;
    if (!dateStr || !r || r.days <= 1) return '';
    var n = daysFromTodaySGT(dateStr);
    if (n === null || n < r.days || n >= r.days + PAY_WARN_EXTRA) return '';
    // Kalimat Boss 30-09-2026, grammar dirapikan. "whole lamb" ditulis tetap,
     // karena hanya lamb yang punya minDays di atas 1 saat ini.
    return 'Your date is ' + n + ' days away. Please complete your payment today to have your whole lamb ready in time.';
  }
  function renderPayWarn(box, body, dateStr) {
    if (!box || !body) return;
    var t = payWarnText(dateStr);
    body.textContent = t;
    box.setAttribute('data-active', t ? 'true' : 'false');
  }

  // Batas kalender, teks bantuan, dan disclaimer mengikuti state.rule.
  function applyRule() {
    var r = state.rule;
    ui.date.min = sgtPlusDays(r.days);
    if (ui.dateHelp && ui.dateError) {
      if (r.days <= 1) {
        ui.dateHelp.textContent = 'Earliest booking is tomorrow.';
        ui.dateError.textContent = 'Please choose an event date from tomorrow onwards.';
      } else {
        var nice = niceDate(sgtPlusDays(r.days));
        ui.dateHelp.textContent = r.title + ' needs at least ' + r.days + ' days\u2019 notice. Earliest booking is ' + nice + '.';
        ui.dateError.textContent = 'Please choose an event date from ' + nice + ' onwards.';
      }
    }
    if (ui.discFull) ui.discFull.hidden = !r.serviceOnly;
    if (ui.discQuick) ui.discQuick.hidden = !r.serviceOnly;
  }

  function openFull(productTitle, booking, mode, rule, opts) {
    state.mode = mode || 'add';
    var editing = state.mode === 'edit';
    opts = opts || {};
    state.rule = rule || { days: 1, title: productTitle, serviceOnly: true };
    if (opts.addServiceOnly !== undefined) state.addServiceOnly = opts.addServiceOnly;

    ui.modeFull.hidden = false;
    ui.modeQuick.hidden = true;
    ui.change.hidden = true;
    ui.confirm.textContent = editing ? 'Save booking details' : 'Confirm and Add to Cart';
    ui.subtitle.textContent = editing ? 'Applies to everything in your cart' : productTitle;
    var crew = 'Our crew will arrive 1 to 2 hours before your booking time to set up and prepare.';
    ui.arrival.textContent = editing
      ? (state.rule.serviceOnly
          ? 'Your chef or assistant will arrive 1 to 2 hours before your booking time to set up and prepare.'
          : crew)
      : (state.addServiceOnly
          ? 'Our ' + productTitle + ' will arrive 1 to 2 hours before your booking time to set up and prepare.'
          : crew);
    applyRule();
    if (booking) {
      ui.time.value = booking.time || '';
      ui.date.value = booking.date || '';
      ui.duration.value = booking.duration || '';
      ui.guests.value = booking.guests || '';
      ui.notes.value = booking.notes || '';
    }
    // Booking lama di keranjang terlalu dekat untuk produk ini: tanggalnya
    // dikosongkan dan pelanggan diminta memilih ulang untuk seluruh booking.
    if (opts.tooEarly && booking) {
      ui.arrival.textContent = 'Your cart already has a booking on ' + niceDate(booking.date) + '. ' +
        state.rule.title + ' needs at least ' + state.rule.days + ' days\u2019 notice, so please choose a new ' +
        'date. It will apply to everything in your cart.';
      ui.date.value = '';
    }
    // Kalimat kedatangan umum ("Our crew will arrive...") dulu disembunyikan
    // khusus untuk whole lamb (Boss 30-09-2026). Lamb keluar dari gerbang sejak
    // 01-10-2026, dan untuk paket berisi crew (04-10-2026) kalimat itu benar,
    // jadi kotaknya selalu tampil. Lamb tetap tersembunyi lewat scheduleNote
    // seandainya dia masuk lagi. Pakai style.display, karena .sbg-notice diberi
    // display:flex sehingga atribut hidden kalah.
    var arrivalBox = ui.arrival.closest ? ui.arrival.closest('.sbg-notice') : null;
    var lambOnly = state.variantId && entryFor(state.variantId).scheduleNote === true;
    if (arrivalBox) arrivalBox.style.display = (lambOnly && ui.arrival.textContent === crew) ? 'none' : '';
    ['time', 'date', 'duration', 'guests'].forEach(function (n) { setInvalid(n, false); });
    renderCrewWarn();
    renderSurcharge();
    renderPayWarn(ui.payWarn, ui.payWarnB, ui.date.value);
    show();
  }

  function openQuick(productTitle, booking, rule) {
    state.mode = 'add';
    state.rule = rule || { days: 1, title: productTitle, serviceOnly: true };
    applyRule();
    renderPayWarn(ui.payWarnQ, ui.payWarnQB, booking.date);
    ui.modeFull.hidden = true;
    ui.modeQuick.hidden = false;
    ui.change.hidden = false;
    ui.confirm.textContent = 'Confirm and Add to Cart';
    ui.subtitle.textContent = productTitle;

    var d = sgtInstant(booking.date, booking.time);
    var nice = d ? d.toLocaleDateString('en-SG', {
      weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Singapore'
    }) : booking.date;

    var rows = [
      ['Event Date', nice],
      ['Booking Time', booking.time],
      ['Dining Duration', booking.duration],
      ['Number of Guests', booking.guests]
    ];
    if (booking.notes) rows.push(['Additional Notes', booking.notes]);

    ui.summary.innerHTML = rows.map(function (r) {
      return '<div class="sbg-summary-row"><span class="sbg-summary-key">' + r[0] +
             '</span><span class="sbg-summary-val">' + escapeHtml(r[1]) + '</span></div>';
    }).join('');

    renderCrewWarn();
    var band = bandFor(booking.date, booking.time);
    if (band) {
      // Per manpower (04-10-2026): produk tambahan MENAMBAH surcharge sesuai crew-nya,
      // termasuk crew yang ditambahkan karena jumlah tamu (05-10-2026).
      var crew = crewTotal();
      ui.surQ.setAttribute('data-active', 'true');
      ui.surQAmt.textContent = money(band.amount * crew);
      ui.surQCalc.textContent = 'The fee is ' + money(band.amount) + ' per chef or assistant. ' +
        'Your booking will have ' + crewWord(crew) +
        ' and the fee becomes ' + crew + ' x ' + money(band.amount) + ' = ' + money(band.amount * crew) + '.';
    } else {
      ui.surQ.setAttribute('data-active', 'false');
    }
    show();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function show() {
    // Tutup cart drawer kalau sedang terbuka. Tanpa ini, pelanggan yang menambah
    // chef dari rekomendasi di dalam drawer melihat dua panel bertumpuk.
    try {
      var sidebar = document.getElementById('site-cart-sidebar');
      if (sidebar && typeof sidebar.hide === 'function') sidebar.hide();
    } catch (e) {}

    // Tutup modal quick view tema (modal-box, z-index 9999999991) yang sedang
    // terbuka. Tanpa ini popup booking tertimbun di belakangnya (Boss
    // 04-10-2026, Quick add di koleksi live station). hide() milik tema hanya
    // menyembunyikan modal, form-nya tetap di DOM, jadi requestSubmit() sesudah
    // Confirm tetap berjalan.
    try {
      document.querySelectorAll('modal-box.active').forEach(function (m) {
        if (typeof m.hide === 'function') m.hide();
      });
    } catch (e) {}

    ui.overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { ui.overlay.focus(); }, 30);
  }

  function hide() {
    ui.overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    state.capBlocked = false;
    if (ui.capWarn) ui.capWarn.setAttribute('data-active', 'false');
    if (ui.confirm && ui.confirm.getAttribute('data-busy') !== 'true') ui.confirm.disabled = false;
    state.form = null;
    state.variantId = null;
    // Booking yang tertinggal tanpa crew dibersihkan sesudah modal ditutup.
    // Sesudah Confirm, penahan waktu di onConfirm yang melindungi atributnya.
    // 'force': popup peringatan jumlah tamu ditutup tanpa menurunkan tamu,
    // jadi crew yang kurang ditambahkan tanpa bertanya lagi.
    scheduleReconcile('force');
  }

  /* ======================================================================
     8. Gerbang. Intersepsi di fase CAPTURE pada document, supaya selalu
        berjalan sebelum listener submit milik <product-form> tema.
     ====================================================================== */

  /* Form mana yang dijaga. Form vendor (data-type="add-to-cart-form") seperti
     sebelumnya. Sejak 30-09-2026 form lain yang action-nya ke /cart/add, yaitu
     form v2 shiok-product-main-v2 milik halaman lamb, ikut dijaga HANYA untuk
     variant non-jasa. Chef/assistant tidak berubah sama sekali. */
  function isGateForm(form, variantId) {
    if (!isGated(variantId)) return false;
    if (form.matches('form[data-type="add-to-cart-form"]')) return true;
    return form.matches('form[action*="/cart/add"]') && !isServiceOnly(variantId);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    if (form.dataset.sbgPassed === '1') return;          // sudah lolos gerbang

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !isGateForm(form, idInput.value)) return;  // bukan produk yang dijaga

    e.preventDefault();
    e.stopPropagation();                                  // blokir listener tema

    state.form = form;
    state.variantId = idInput.value;

    gateOpen(idInput.value);
  }, true);

  /* Membuka modal untuk variant yang sedang ditambahkan. Syaratnya produk
     terberat di keranjang plus variant ini. Booking yang sudah ada dipakai
     ulang (mode cepat) selama tanggalnya memenuhi syarat itu; kalau tidak,
     form penuh dibuka dengan tanggal dikosongkan. Untuk syarat 1 hari
     (chef/assistant) mode cepat selalu dipakai, persis seperti sebelumnya. */
  function gateOpen(variantId) {
    var title = entryFor(variantId).productTitle || 'chef';
    var addSO = isServiceOnly(variantId);
    state.addServiceOnly = addSO;
    state.crewBase = 0;
    state.crewAdd = staffFor(variantId) * formQty(state.form);
    state.hireVid = firstHire([variantId]);
    state.bookingIds = [variantId];
    getCart().then(function (cart) {
      var booking = bookingFromCart(cart);
      state.booking = booking;
      var chefLines = splitCart(cart).chef.filter(notTopUp);  // tanpa baris tambahan sistem
      state.cartFood = foodLines(cart); state.topQty = topQtyOf(cart);  // kapasitas paket + Additional yang sudah ada
      state.crewBase = crewOfLines(chefLines);
      var ids = chefLines.map(function (it) { return it.variant_id; });
      // Hire yang sedang ditambahkan didahulukan, lalu hire yang sudah di keranjang.
      state.hireVid = firstHire([variantId].concat(ids));
      state.bookingIds = [variantId].concat(ids);
      var rule = ruleFor(ids.concat([variantId]));
      var tooEarly = !!booking && rule.days > 1 && booking.date < sgtPlusDays(rule.days);
      if (booking && !tooEarly) openQuick(title, booking, rule);
      else openFull(title, booking, 'add', rule, { tooEarly: tooEarly, addServiceOnly: addSO });
    }).catch(function () {
      state.booking = null;
      state.cartFood = []; state.topQty = 0;
      openFull(title, null, 'add', ruleFor([variantId]), { addServiceOnly: addSO });
    });
  }

  /* ======================================================================
     9. Confirm
     ====================================================================== */

  function passThrough(booking, band) {
    var form = state.form;
    if (!form) { hide(); return; }

    // buang suntikan lama, lalu suntik properti baru KE DALAM form
    form.querySelectorAll('input[data-sbg-injected]').forEach(function (n) { n.remove(); });
    var props = propsFor(booking, band, state.variantId);
    Object.keys(props).forEach(function (k) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + k + ']';
      i.value = props[k];
      i.setAttribute('data-sbg-injected', '1');
      form.appendChild(i);
    });

    form.dataset.sbgPassed = '1';
    hide();

    var btn = form.querySelector('[type="submit"]');
    if (form.requestSubmit) form.requestSubmit(btn || undefined);
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

    setTimeout(function () { delete form.dataset.sbgPassed; }, 1500);
  }

  function setConfirmBusy(on, label) {
    if (!ui.confirm) return;
    ui.confirm.disabled = !!on;
    ui.confirm.setAttribute('data-busy', on ? 'true' : 'false');
    if (on) {
      if (!ui.confirm.dataset.labelBefore) ui.confirm.dataset.labelBefore = ui.confirm.textContent;
      ui.confirm.textContent = label || 'Saving...';
    } else if (ui.confirm.dataset.labelBefore) {
      ui.confirm.textContent = ui.confirm.dataset.labelBefore;
      delete ui.confirm.dataset.labelBefore;
    }
  }

  function onConfirm() {
    var isQuick = ui.modeQuick.hidden === false;
    var booking = isQuick ? state.booking : readForm();

    if (!isQuick && !validate(true)) return;
    // Kapasitas paket lebih kecil dari jumlah tamu: diblok (Boss 05-10-2026).
    renderCapacity();
    if (state.capBlocked) return;

    var band = bandFor(booking.date, booking.time);
    var editing = state.mode === 'edit';

    // Modal SENGAJA tidak langsung ditutup. Menyimpan booking berarti bicara ke
    // Cart API Shopify beberapa kali, dan itu perlu waktu. Kalau modal ditutup
    // duluan, pelanggan melihat keranjang lama dan mengira perubahannya gagal.
    if (!editing) state.holdAttrsUntil = Date.now() + 10000;
    setConfirmBusy(true, editing ? 'Saving...' : 'Adding to cart...');
    busy(true);

    var selesai = function () { setConfirmBusy(false); busy(false); };

    // Total crew sesudah penambahan ini. Reconcile menyelaraskan lagi dari
    // keranjang sungguhan sesudah tema selesai menambahkan.
    setAttributes(attrsFor(booking, band, crewTotal()))
      .catch(function () {})
      .then(function () { return applyToExistingLines(booking, band); })
      .catch(function () {})
      .then(function () {
        if (editing) {
          state.mode = 'add';
          // Simpan = jalankan aturan biasa: kalau tamu masih butuh crew lebih,
          // kekurangannya ditambahkan sekarang (tanpa bertanya lagi).
          state.nextReason = null;
          // Properti tiap baris ikut berubah walaupun surcharge tidak berubah,
          // jadi tampilan tetap harus dirender ulang setelah reconcile selesai.
          return reconcile()
            .then(function () { return refreshCartView(); })
            .then(function () { selesai(); hide(); });
        }
        selesai();
        passThrough(booking, band);
      })
      .catch(function () { selesai(); hide(); });
  }

  // kalau booking diubah, semua baris chef/assistant yang sudah ada ikut diperbarui
  function applyToExistingLines(booking, band) {
    return getCart().then(function (cart) {
      var parts = splitCart(cart);
      if (!parts.chef.length) return;
      var chain = Promise.resolve();
      // Baris tambahan sistem tidak membawa data booking; reconcile yang
      // memperbarui keterangannya mengikuti jumlah tamu baru.
      parts.chef.filter(notTopUp).forEach(function (it) {
        var props = propsFor(booking, band, it.variant_id);
        chain = chain.then(function () { return changeLine(it.key, { properties: props }); });
      });
      return chain;
    });
  }

  /* ======================================================================
     9b. Link "Edit" di keranjang.
         Bar ringkasan booking dihapus atas permintaan Boss (20-09-2026).
         Penggantinya link Edit kecil di sebelah Remove, dirender oleh
         snippets/cart-form.liquid dan cart-form-page.liquid pada baris yang
         punya data booking. Tanpa ini, keterangan pada baris surcharge
         ("change the Event Date on your booking") jadi instruksi buntu.
     ====================================================================== */

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-sbg-edit]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    getCart().then(function (cart) {
      var booking = bookingFromCart(cart);
      if (!booking) return;
      state.form = null;
      state.variantId = null;
      state.booking = booking;
      var chefLines = splitCart(cart).chef.filter(notTopUp);  // tanpa baris tambahan sistem
      state.cartFood = foodLines(cart); state.topQty = topQtyOf(cart);  // kapasitas paket + Additional yang sudah ada
      state.crewBase = crewOfLines(chefLines);
      state.crewAdd = 0;
      var ids = chefLines.map(function (it) { return it.variant_id; });
      state.hireVid = firstHire(ids);
      state.bookingIds = ids;
      openFull('', booking, 'edit', ruleFor(ids));
      // Dibuka dari Remove/Edit di baris crew tambahan (Boss 05-10-2026).
      if (btn.getAttribute('data-sbg-edit') === 'crew' && state.hireVid) {
        var role = roleOfHire(state.hireVid);
        ui.arrival.textContent = 'The extra ' + plural(role, 2) + ' follow your Number of Guests. ' +
          'To remove them, lower the Number of Guests below and save.';
      }
    });
  }, true);

  /* ======================================================================
     10. Bind
     ====================================================================== */

  function init() {
    if (!cacheUI()) return;

    ui.confirm.addEventListener('click', onConfirm);
    ui.close.addEventListener('click', hide);
    ui.change.addEventListener('click', function () {
      openFull(ui.subtitle.textContent, state.booking, 'add', state.rule, { addServiceOnly: state.addServiceOnly });
    });
    ui.overlay.addEventListener('click', function (e) { if (e.target === ui.overlay) hide(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ui.overlay.getAttribute('data-open') === 'true') hide();
    });

    ['change', 'input'].forEach(function (ev) {
      ui.date.addEventListener(ev, function () {
        renderSurcharge(); setInvalid('date', false);
        renderPayWarn(ui.payWarn, ui.payWarnB, ui.date.value);
      });
      ui.time.addEventListener(ev, function () { renderSurcharge(); setInvalid('time', false); });
    });
    ui.duration.addEventListener('change', function () { setInvalid('duration', false); });
    ui.guests.addEventListener('input', function () {
      setInvalid('guests', false);
      renderCrewWarn();      // peringatan jumlah tamu, langsung saat diketik
      renderSurcharge();     // surcharge ikut jumlah crew yang dibutuhkan
    });

    // Klik di mana pun pada field tanggal membuka kalender, bukan cuma di ikonnya.
    // showPicker() butuh gesture pengguna, jadi dipasang di click. Kalau browser
    // menolak (atau belum mendukung), perilaku bawaan tetap jalan.
    function openDatePicker(e) {
      if (typeof ui.date.showPicker !== 'function') return;
      try { ui.date.showPicker(); if (e) e.preventDefault(); } catch (err) {}
    }
    ui.date.addEventListener('click', openDatePicker);
    ui.date.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') openDatePicker(e);
    });

    ui.date.min = tomorrowSGT();


    // Ambil alih dari penjaga awal di snippet. Kalau pelanggan sempat menekan
    // Add to Cart sebelum skrip ini termuat, form-nya ditahan di sana dan
    // dilanjutkan di sini, jadi kliknya tidak hilang percuma.
    window.__SBG_READY__ = true;
    if (typeof window.__SBG_EARLY_OFF__ === 'function') window.__SBG_EARLY_OFF__();
    var pending = window.__SBG_PENDING__;
    window.__SBG_PENDING__ = null;
    if (pending && pending.isConnected) {
      var pid = pending.querySelector('input[name="id"]');
      if (pid && isGateForm(pending, pid.value)) {
        state.form = pending;
        state.variantId = pid.value;
        gateOpen(pid.value);
      }
    }

    /* Hitung ulang band, TAPI hanya kalau keranjang memang berisi chef,
       assistant, atau baris surcharge. Tanpa salah satunya, runReconcileOnce
       terbukti tidak melakukan apa apa: aturan 1 butuh baris surcharge, dan
       aturan 2 sampai 6 langsung dilewati oleh `if (!parts.chef.length) return`.
       Jadi melewatinya menghemat dua panggilan /cart.js di hampir setiap
       kunjungan, tanpa mengubah hasil apa pun.

       Perhatikan !== false: kalau konfigurasi lama masih ter-cache dan kunci
       ini belum ada, perilakunya kembali seperti sebelumnya, bukan mati diam. */
    if (CFG.cartNeedsReconcile !== false) scheduleReconcile();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.SBG = { reconcile: reconcile, bandFor: bandFor, hoursUntilEvent: hoursUntilEvent, staffFor: staffFor, config: CFG };
})();
